import { apiClient, API_BASE_URL } from './apiClient';

const BASE = `${API_BASE_URL}/api/paint/competitors`;

export const paintCompetitorsAPI = {
  listTcoat: () => apiClient(`${API_BASE_URL}/api/quotations/products`),
  listProducts: () => apiClient(BASE),
  createProduct: (data) => apiClient(BASE, { method: 'POST', body: JSON.stringify(data) }),
  updateProduct: (id, data) => apiClient(`${BASE}/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  removeProduct: (id) => apiClient(`${BASE}/${id}`, { method: 'DELETE' }),

  listMatches: () => apiClient(`${BASE}/matches`),
  createMatch: (data) => apiClient(`${BASE}/matches`, { method: 'POST', body: JSON.stringify(data) }),
  updateMatch: (id, data) => apiClient(`${BASE}/matches/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  removeMatch: (id) => apiClient(`${BASE}/matches/${id}`, { method: 'DELETE' }),
};

export default paintCompetitorsAPI;
